import gql from 'graphql-tag';

import type { Job } from 'src/data/job';
import { executeGqlMutation } from 'src/graphql/client';
import { FRAGMENT_JOB } from 'src/graphql/job';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ImportBrandTermsUsingIntegration(
    $workspaceId: ID!
    $brandVoiceId: ID!
    $integrationRequestId: ID!
    $instructions: String
  ) {
    importBrandTermsUsingIntegration(
      workspaceId: $workspaceId
      brandVoiceId: $brandVoiceId
      integrationRequestId: $integrationRequestId
      instructions: $instructions
    ) {
      ...Job
    }
  }
  ${FRAGMENT_JOB}
`;

interface ImportBrandTermsUsingIntegrationParams {
  workspaceId: string;
  brandVoiceId: string;
  integrationRequestId: string;
  instructions: string | null;
}

export const importBrandTermsUsingIntegration = ({
  workspaceId,
  brandVoiceId,
  integrationRequestId,
  instructions,
}: ImportBrandTermsUsingIntegrationParams) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { workspaceId, brandVoiceId, integrationRequestId, instructions },
    options: {
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp<Job>(data));
};
